module.exports = __webpack_public_path__ + "img/solidpayments2.f01e0fa0.svg";